export default __webpack_public_path__ + "static/media/ccna.9e36b3d0.png";